import LoadingIcon from "../../../../../components/Loading";
import CloseIcon from "../../../../../components/CloseIcon";

const RequestPanel = ({
  isSaving,
  isLoading,
  goBack,
  children,
  title = "Route Validation",
}: {
  isSaving: boolean;
  isLoading: boolean;
  goBack: () => void;
  children: React.ReactElement;
  title?: string;
}) => {
  return (
    <div id="routeValidationPanel"className="routeValidationPanel">
      {isSaving && (
        <div
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "rgba(0,0,0,.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1005,
          }}
        >
          <LoadingIcon color="white" height={200} width={200} />
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
          borderBottom: "1px solid #D9D9D9",
          margin: "0 20px",
        }}
      >
        {/* BACK BUTTON */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 15,
            right: 15,
            position: "absolute",
          }}
        >
          <CloseIcon onClick={goBack} />
        </div>
        {/* HEADER TEXT */}
        <div
          style={{
            marginLeft: 10,
            marginTop: 30,
            marginBottom: 10,
            display: "flex",
            alignItems: "center",
            fontSize: 21,
            fontWeight: 700,
            font: "Inter",
          }}
        >
          {title}
        </div>
      </div>

      {/* BODY */}
      <div
        style={{
          paddingTop: 20,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        {isLoading && (
          <div>
            <LoadingIcon color="#005CA6" height={100} width={100} />
          </div>
        )}

        {!isLoading && children}
      </div>
    </div>
  );
};

export default RequestPanel;
